import React, { Component } from 'react'
import { Navbar, Nav, Container, Button, Dropdown, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import bootstrap from 'bootstrap'
import FeatherIcon from 'feather-icons-react';
import CusCard from '../components/CusCard'
import '../../node_modules/font-awesome/css/font-awesome.min.css'
import { Row } from 'react-bootstrap';
import CustomFooter from '../components/Footer';
import CustomHeader from '../components/Header'



class GraphsSection extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (


            <div>
                {/* <CustomHeader></CustomHeader> */}

                <Row>
                    <CusCard data1="Fleet" data2="Overview" icon="truck" link="./FleetOverviewSelection" ></CusCard>
                    <CusCard data1="Suspicious" data2="Transactions" icon="shield-off" link="./SuspiciousSelection"></CusCard>
                    <CusCard data1="Safety" data2="Events" icon="alert-triangle" link="./HSSEEventSelection"></CusCard>
                </Row>


            </div>



        );
    }
}


export default GraphsSection;